import { render, staticRenderFns } from "./ServidorMargem.vue?vue&type=template&id=65b64a20&scoped=true&"
import script from "./ServidorMargem.vue?vue&type=script&lang=js&"
export * from "./ServidorMargem.vue?vue&type=script&lang=js&"
import style0 from "./ServidorMargem.vue?vue&type=style&index=0&id=65b64a20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b64a20",
  null
  
)

export default component.exports